export default __webpack_public_path__ + "static/char-s-57-zh-Hant-f1796963bd9408a6b13c6bdff88969eb.webp";